module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAMAAAC3SZ14AAAASFBMVEUAAABicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZlicZkR4OOcAAAAF3RSTlMA7+nfYiW8SB8Y5suzpZJBEaqZh2xWNv1/uOYAAABxSURBVBjTddBLDoMwDEVR20kIKd+2gPe/Uwg84QSJOzySPXiEvIinqqRHqaKQKRSwdS6T6yZCsyjiGeT1bgH9jUbQaPQDfY16kDOSSyYtiic1JTVZVq3yRIlr4pZ6RXb6eRJTfJiL9FbL+FwUBpEBE+7+txE8iuVa4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_notice1.png
// module id = TeIC
// module chunks = 9